import apiClient from './client';
import { ChartData, DashboardRecentActivity, DashboardStats } from '@/types';

type DashboardFilter = {
  year?: number;
  month?: number | null;
};

export const dashboardApi = {
  getStats: async (filter: DashboardFilter = {}): Promise<DashboardStats> => {
    const response = await apiClient.get('/api/dashboard/stats', {
      params: filter,
    });
    return response.data;
  },

  getDonaturChart: async (filter: DashboardFilter = {}): Promise<ChartData> => {
    const response = await apiClient.get('/api/dashboard/chart/donatur', {
      params: filter,
    });
    return response.data;
  },

  getBulletinChart: async (filter: DashboardFilter = {}): Promise<ChartData> => {
    const response = await apiClient.get('/api/dashboard/chart/bulletin', {
      params: filter,
    });
    return response.data;
  },

  getDonasiChart: async (year: number, filter: DashboardFilter = {}): Promise<ChartData> => {
    const response = await apiClient.get(`/api/dashboard/chart/donasi/${year}`, {
      params: filter,
    });
    return response.data;
  },

  getRecentActivities: async (limit = 10, filter: DashboardFilter = {}): Promise<{ data: DashboardRecentActivity[] }> => {
    const response = await apiClient.get('/api/dashboard/recent-activities', {
      params: { limit, ...filter },
    });
    return response.data;
  },
};
